<template>
    <div class="loginform">
        <div class="call-button-container">
            <h1 class="loginform__header">404 Not Found</h1>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NotFound"
    }
</script>

<style scoped>
    .loginform {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100vh;
    }

    .loginform__header {
        color: #484848;
        margin-bottom: 30px;
    }

    .loginform__item {
        margin-bottom: 10px;
    }
</style>